// F1: divider bands as live sine paths (same 1592x146 viewBox as the retired
// data-URIs). One shared rAF loop for both waves, frozen off-screen;
// reduced-motion draws a single static frame (F5).
const WAVE_VIEW_W = 1592;
const WAVE_VIEW_H = 146;

const WAVE_STROKES = [
    { base: 0.32, amp: 0.15, periods: 2.0, speed: 0.26, phase: 0.0 },
    { base: 0.5, amp: 0.12, periods: 2.0, speed: 0.18, phase: 2.1 },
    { base: 0.66, amp: 0.17, periods: 2.0, speed: 0.34, phase: 4.2 },
];

const waveY = (stroke, x, mirror, t) => {
    const breathe = 0.8 + 0.2 * Math.sin(t * 0.23 + stroke.phase);
    const direction = mirror ? -1 : 1;
    // Quarter-period offset so t=0 (first paint, static frame) shows the
    // full shape instead of a flat line.
    const standing = Math.sin(direction * (x / WAVE_VIEW_W) * Math.PI * 2 * stroke.periods + stroke.phase) * Math.sin(t * stroke.speed + Math.PI / 2 + stroke.phase);
    return (stroke.base + stroke.amp * breathe * standing) * WAVE_VIEW_H;
};

export const initWaves = () => {
    const svgs = [...document.querySelectorAll(".wave-svg")];
    if (svgs.length === 0) {
        return;
    }
    const waves = svgs.map(svg => ({
        element: svg.closest(".wave"),
        paths: [...svg.querySelectorAll(".wave-stroke")],
        mirror: svg.closest("#wave-2") !== null,
    })).filter(wave => wave.paths.length === WAVE_STROKES.length);
    if (waves.length === 0) {
        return;
    }

    const draw = t => {
        waves.forEach(wave => {
            wave.paths.forEach((path, i) => {
                const stroke = WAVE_STROKES[i];
                let d = "";
                for (let x = 0; x <= WAVE_VIEW_W; x += 8) {
                    d += (x === 0 ? "M" : "L") + x + " " + waveY(stroke, x, wave.mirror, t).toFixed(1);
                }
                path.setAttribute("d", d);
            });
        });
    };

    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        draw(0);
        return;
    }

    let rafId = 0;
    const visible = () => waves.some(wave => wave.element === null || !wave.element.classList.contains("is-paused"));
    const frame = now => {
        draw(now / 1000);
        rafId = visible() ? window.requestAnimationFrame(frame) : 0;
    };
    const updateLoop = () => {
        if (visible() && rafId === 0) {
            rafId = window.requestAnimationFrame(frame);
        }
    };

    if ("IntersectionObserver" in window) {
        const freezeOffscreen = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                entry.target.classList.toggle("is-paused", !entry.isIntersecting);
            });
            if (!visible() && rafId !== 0) {
                window.cancelAnimationFrame(rafId);
                rafId = 0;
            }
            updateLoop();
        });
        waves.forEach(wave => {
            if (wave.element !== null) {
                freezeOffscreen.observe(wave.element);
            }
        });
    }

    draw(0);
    updateLoop();
};
